import { TextLargeParagraph } from '@carboncopyco/ui';
import { BadgeWithTooltip } from '../../../BadgeWithTooltip';
import { TitleCard } from '../../InfoPageCards/TitleCard';
import { TabLayout } from '../../TabLayout';
import { TourPageActionButtons } from '../TourPageActionButtons';
import { TourPageBreadcrumbs } from '../TourPageBreadcrumbs';
import { useTourPageProps } from '../TourPageContext';
import { TourPageTitle } from '../TourPageTitle';
import { RevisionsTable } from './RevisionsTable';

export const HistoryTab = () => {
  const { readOnly } = useTourPageProps();
  return (
    <TabLayout
      title={<TourPageTitle />}
      entity="tour"
      breadcrumbs={<TourPageBreadcrumbs />}
      actionButtons={<TourPageActionButtons />}
      secondaryActionButtons={
        readOnly ? (
          <div className="flex items-center gap-1">
            <BadgeWithTooltip
              tooltipText="This asset is shared from another workspace. You can view and present it."
              badgeProps={{
                label: 'Read only',
                variant: 'primary',
              }}
            />
          </div>
        ) : null
      }
    >
      <div>
        <TitleCard
          radius
          header={
            <div className="flex p-6">
              <TextLargeParagraph
                color="text-ds-natural-700"
                label="Version history"
              />
            </div>
          }
        >
          <RevisionsTable />
        </TitleCard>
      </div>
    </TabLayout>
  );
};
